import { Navigate } from 'react-router-dom'
import { authApi } from '../../api/auth'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const token = authApi.getToken()

  if (!token) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
